import {
  Box, Button, FormField, SectionDivider, SidebarModal,
} from '@domain-group/suit-theme'
import { useSetState } from '@domain-group/react-hooks'

import type { SidebarModalProps } from '@domain-group/suit-theme'

import useTemplateGroup, { useTemplateGroupForm } from '@hooks/useTemplateGroup'

import EntitySelector from '@components/EntitySelector'
import ToggleListItem from '@components/ToggleListItem'

import ProjectOptions from './ProjectOptions'

const MODAL_KEY = 'CreateTemplateGroupModal'

const defaultState = {
  createWithProject: true,
}

type CreateTemplateGroupModalProps = {
  callbacks: {
    createTemplateGroup: (payload: object) => void,
  },
  requestOptions?: object,
  titleSecondLine?: string,
}

const CreateTemplateGroupModal = (props: SidebarModalProps & CreateTemplateGroupModalProps) => {
  const {
    callbacks,
    callbacks: { closeModal, createTemplateGroup },
    requestOptions,
    showModal,
    titleSecondLine,
  } = props

  const [state, setState] = useSetState(defaultState)
  const { createWithProject } = state

  const templateGroupPayload = useTemplateGroup({})
  const {
    callbacks: {
      createTemplateGroup: createFn,
      createTemplateGroupWithProject: createWithProjectFn,
    },
  } = templateGroupPayload

  const formPayload = useTemplateGroupForm({}, {
    defaultFormStateParams: {
      create_master_suite_section: true,
    },
    validateOn: 'change',
  })

  const {
    creating,
    entityState,
    entityState: { brand_id, title },
    handlers,
    saveEnabled,
    setEntityState,
  } = formPayload

  const createTemplateGroupPayload = {
    callbacks: {
      action: createWithProject ? createWithProjectFn : createFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    requestOptions,
    shouldRedirect: true,
    toastText: 'Template Group Created',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Create" titleSecondLine={titleSecondLine || 'Template Group'} />

      <SidebarModal.Content>
        <Box flexDirection="column">
          <EntitySelector
            // @ts-expect-error TS2741
            callbacks={{
              selectItem: brand => setEntityState({
                brand_id: brand?.id,
                debtor_id: brand?.debtor_agency_id,
                debtor_type: 'Agency',
              }),
            }}
            label="* Brand"
            entityKey="brands"
            selectedItemId={brand_id}
          />

          <FormField direction="column" label="* Title" marginTop="large">
            <input name="title" type="text" value={title} {...handlers} />
          </FormField>

          <SectionDivider boxProps={{ marginY: 'large' }}>OPTIONS</SectionDivider>

          <ToggleListItem
            onClick={() => setState({ createWithProject: !createWithProject })}
            toggleValue={createWithProject}
          >
            <ToggleListItem.Title>Create Project</ToggleListItem.Title>
            <ToggleListItem.Description>
              A new project will created along with the template group
            </ToggleListItem.Description>
          </ToggleListItem>

          {createWithProject && <ProjectOptions callbacks={{ setEntityState }} entityState={entityState} />}
        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={creating}
          loadingBubbleColor="white"
          onClick={() => createTemplateGroup(createTemplateGroupPayload)}
          size="large"
        >
          {createWithProject ? 'Create Group & Project' : 'Create Group'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: SidebarModalProps & CreateTemplateGroupModalProps) => (
  <SidebarModal.RenderController {...props}>
    <CreateTemplateGroupModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
